import React, { useEffect, useState } from "react";
import { ModalBody, ModalHeader } from "reactstrap";
import checkoutSubscriptionEnhancer from "../enhancer/checkoutSubscriptionEnhancer";
import { connect } from "react-redux";
import { compose } from "redux";
import navigationAction from "redux/navigation/actions";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { create_checkout } from "services/subscriptionServices";
import Loader from "components/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { usePlacesWidget } from "react-google-autocomplete";

const { success, error } = navigationAction;

function CheckoutSubscriptionForm(props) {
  const {
    closeModal,
    getFieldProps,
    setFieldValue,
    values,
    errors,
    touched,
    submitCount,
    token,
    user,
    setValues,
    isValid,
    handleSubmit
  } = props;

  const [loading, setLoading] = useState(false);
  const [existingCard, setExistingCard] = useState(
    user.user_payment_method_id === undefined ||
      user.user_payment_method_id === "" ||
      user.user_payment_method_id === null
      ? "new"
      : "existing"
  );

  const handleCheckout = async e => {
    handleSubmit();
    console.log("Values after submit", user?._id);
    // setValues({ ...values, customer_id: user?._id });

    let data = {
      ...values,
      customer_id: user?._id,
      expirydate: moment(values.expirydate).format("MM/yyyy")
    };
    console.log("isvlaid", isValid, errors);
    if (isValid) {
      setLoading(true);
      await create_checkout(token, user?._id, data).then(res => {
        if (res.success) {
          success(res.message);
          // console.log(res, "response");
          window.location.href = res.data.url;
          closeModal();
          setLoading(false);
        } else {
          error(res.message);
          setLoading(false);
        }
      });
    }
  };

  function cc_format(value) {
    const v = value
      .replace(/\s+/g, "")
      .replace(/[^0-9]/gi, "")
      .substr(0, 16);
    const parts = [];

    for (let i = 0; i < v.length; i += 4) {
      parts.push(v.substr(i, 4));
    }
    return parts.length > 1 ? parts.join(" ") : value;
  }

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  // const { ref } = usePlacesWidget({
  //   apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  //   onPlaceSelected: (place) => {
  //     FormatePlaces(place);
  //   },
  //   options: {
  //     componentRestrictions: { country: "au" },
  //     fields: ["address_components", "geometry"],
  //     types: ["address"],
  //   },
  // });

  // const FormatePlaces = (place) => {
  //   let address1 = "";
  //   let address2 = "";
  //   let postcode = "";
  //   let state = "";
  //   let city = "";
  //   console.log(place);
  //   for (const component of place.address_components) {
  //     // @ts-ignore remove once typings fixed
  //     const componentType = component.types[0];

  //     switch (componentType) {
  //       case "street_number": {
  //         address1 = `${component.long_name} ${address1}`;
  //         break;
  //       }

  //       case "route": {
  //         address2 += component.long_name;
  //         break;
  //       }

  //       case "postal_code": {
  //         postcode = `${component.long_name}${postcode}`;
  //         break;
  //       }

  //       case "postal_code_suffix": {
  //         postcode = `${postcode}-${component.long_name}`;
  //         break;
  //       }
  //       case "locality":
  //         city = component.long_name;
  //         break;
  //       case "administrative_area_level_1": {
  //         state = component.short_name;
  //         break;
  //       }
  //       default: {
  //       }
  //     }
  //   }
  //   setFieldValue("address_line1", address1);
  //   setFieldValue("address_line2", address2);
  //   setFieldValue("city", city);
  //   setFieldValue("state", state);
  //   setFieldValue("postal_code", postcode);
  // };

  useEffect(() => {
    if (
      user &&
      (user.user_payment_method_id === undefined ||
        user.user_payment_method_id === "" ||
        user.user_payment_method_id === null)
    ) {
      setFieldValue("existingCard", "new");
    } else {
      setFieldValue("existingCard", "existing");
    }
  }, []);

  return (
    <>
      <ModalHeader toggle={props.closeModal}>Subscription Form</ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="firstName">
                First Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter first name"
                {...getFieldProps("firstName")}
              />
              <Error field="firstName" />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="lastName">
                Last Name <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter last name"
                {...getFieldProps("lastName")}
              />
              <Error field="lastName" />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="email">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control react-form-inputcustom-input-class "
                placeholder="Enter email"
                {...getFieldProps("email")}
              />
              <Error field="email" />
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <label htmlFor="address_line1">
                Address Line 1 <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter Address Line 1"
                {...getFieldProps("address_line1")}
                // ref={ref}
              />
              <Error field="address_line1" />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="address_line2">
                Address Line 2 <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter Address Line 2"
                {...getFieldProps("address_line2")}
              />
              <Error field="address_line2" />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="city">
                City <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter city"
                {...getFieldProps("city")}
              />
              <Error field="city" />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="state">
                State <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter state"
                {...getFieldProps("state")}
              />
              <Error field="state" />
            </div>
          </div>
          {/* <div className="col-6">
            <div className="form-group">
              <label htmlFor="country">
                Country <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input"
                placeholder="Enter country"
                {...getFieldProps("country")}
              />
              <Error field="country" />
            </div>
          </div> */}
          <div className="col-6">
            <div className="form-group">
              <label htmlFor="postal_code">
                Postal Code <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control react-form-input custom-input-class"
                placeholder="Enter postal code"
                {...getFieldProps("postal_code")}
              />
              <Error field="postal_code" />
            </div>
          </div>
        </div>
        <div className="row">
          {user.user_payment_method_id === undefined ||
          user.user_payment_method_id === "" ||
          user.user_payment_method_id === null ? (
            <></>
          ) : (
            <>
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="existingCard">
                    Existing Card <span className="text-danger">*</span>
                  </label>
                  <div>
                    <input
                      type="radio"
                      name="radio1"
                      id="radio1"
                      value={"existing"}
                      checked={existingCard === "existing"}
                      onChange={() => {
                        setExistingCard("existing");
                        setValues({
                          ...values,
                          existingCard: "existing",
                          cardname: "",
                          cardnumber: "",
                          cvc: "",
                          expirydate: undefined
                        });
                      }}
                    />
                    <label className="ml-1" htmlFor="radio1">
                      Existing Card
                    </label>
                    &ensp;&ensp;
                    <input
                      type="radio"
                      name="radio2"
                      id="radio2"
                      value={"new"}
                      checked={existingCard === "new"}
                      onChange={() => {
                        setExistingCard("new");
                        setValues({
                          ...values,
                          existingCard: "new",
                          cardname: "",
                          cardnumber: "",
                          expirydate: undefined,
                          cvc: ""
                        });
                      }}
                    />
                    <label className="ml-1" htmlFor="radio2">
                      New Card
                    </label>
                  </div>
                  <Error field="existingCard" />
                </div>
              </div>
            </>
          )}
          {existingCard === "new" ? (
            <>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="cardname">
                    Card Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input custom-input-class"
                    placeholder="Enter card name"
                    {...getFieldProps("cardname")}
                  />
                  <Error field="cardname" />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="cardnumber">
                    Card Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input custom-input-class"
                    placeholder="Enter card number"
                    {...getFieldProps("cardnumber")}
                    maxLength={19}
                    autoFocus
                    value={cc_format(values.cardnumber)}
                  />
                  <Error field="cardnumber" />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="expirydate">
                    Expiry Date <span className="text-danger">*</span>
                  </label>
                  <div>
                    <DatePicker
                      selected={Date.parse(values.expirydate)}
                      placeholderText="MM/YYYY"
                      className="form-control react-form-input custom-input-class"
                      calendarClassName="custom-calender-class"
                      name="expirydate"
                      id="expirydate"
                      onChange={date => setFieldValue("expirydate", date)}
                      onKeyDown={e => {
                        e.preventDefault();
                      }}
                      // {...getFieldProps("expirydate")}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      minDate={moment().startOf("month")._d}
                      value={values.expirydate}
                    />
                    <Error field="expirydate" />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="cvc">
                    CVV <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control react-form-input custom-input-class"
                    placeholder="Enter cvv"
                    {...getFieldProps("cvc")}
                  />
                  <Error field="cvc" />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="col-12 mt-3 ModalBtnGroup">
            <div className="row">
              <div className="col-6 pr-2">
                <button
                  className="btn btn-info w-100 btn-bordered form-button modalAddButton"
                  onClick={handleCheckout}
                >
                  Submit
                </button>
              </div>
              <div className="col-6 pl-2">
                <button
                  className="btn btn-dark w-100 btn-bordered form-button modalCancleButton"
                  onClick={() => closeModal()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      {loading && <Loader />}
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  checkoutSubscriptionEnhancer,
  connect(mapStateToProps, { error, success })
)(CheckoutSubscriptionForm);
